// extracted by mini-css-extract-plugin
module.exports =  {"root":"UeR1fItbEJmOgCXrAu9R"};